import AppIconAndroidScreen from './AppIconAndroidScreen'

export default AppIconAndroidScreen
